export default "__VITE_ASSET__mc$qEt1V__"